<template>
    <div id="app">
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>

<script>
const default_layout = 'default'; // eslint-disable-line
export default {
  computed: {
    // Set layout based on meta data passed from vue router
    layout() {
      return `${this.$route.meta.layout || default_layout}-layout`; // eslint-disable-line
    },
  },
};
</script>

<style lang="scss">
    body {
        margin: 0;
    }

    * {
        box-sizing: border-box;
    }
    #app {
        color: #333;
        width: 100%;
        height: 100%;
    }
</style>
